import { Customer } from "./customer";

export type CustomerAction =
  | CustomerSaveAction
  | CustomerTokenSaveAction
  | CustomerPrefillAction;

export const CustomerSaveActionType = "customer/save" as const;
export type CustomerSaveAction = ReturnType<typeof customerSaveAction>;
export function customerSaveAction(customer: Customer) {
  return {
    type: CustomerSaveActionType,
    customer,
  };
}

export const CustomerTokenSaveActionType = "customer-token/save" as const;
export type CustomerTokenSaveAction = ReturnType<
  typeof customerTokenSaveAction
>;
export function customerTokenSaveAction(wcToken: string) {
  return {
    type: CustomerTokenSaveActionType,
    wcToken,
  };
}

export const CustomerPrefillActionType = "customer/prefill" as const;
export type CustomerPrefillAction = ReturnType<typeof customerPrefillAction>;
export function customerPrefillAction(isPrefill: boolean) {
  return {
    type: CustomerPrefillActionType,
    isPrefill,
  };
}
